import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { registerMaintenanceHandler } from './maintenanceManager';
const MaintenanceContext = createContext(undefined);
export const MaintenanceProvider = ({ children }) => {
    const [maintenance, setMaintenance] = useState(false);
    useEffect(() => {
        registerMaintenanceHandler(setMaintenance);
    }, []);
    return (_jsx(MaintenanceContext.Provider, { value: { maintenance, setMaintenance }, children: children }));
};
export const useMaintenance = () => {
    const ctx = useContext(MaintenanceContext);
    if (!ctx) {
        throw new Error('useMaintenance must be used within MaintenanceProvider');
    }
    return ctx;
};
